import { ChevronDownOutline } from '@olist/design-system-icons';
import styled, { css } from 'styled-components';
import { AccordionTrigger } from './AccordionTrigger.js';
import '../../Text/Caption/Caption.js';
import '../../Text/DetailedSubheading/DetailedSubheading.js';
import '../../Text/OverlineLg/OverlineLg.js';
import '../../Text/OverlineMd/OverlineMd.js';
import ParagraphLg from '../../Text/ParagraphLg/ParagraphLg.js';
import '../../Text/ParagraphMd/ParagraphMd.js';
import '../../Text/SectionHeading/SectionHeading.js';
import '../../Text/SectionSubheading/SectionSubheading.js';
import '../../Text/Title/Title.js';
import { fadeIn, fadeOut, slideDown, slideUp } from '../keyframes.js';
import { sideNavAnimationProperties, sideNavTransitionProperties } from '../styles.js';

const AccordionWrapper = styled.nav(({ theme }) => css `
    width: 100%;
    margin-top: ${theme.olist.spacing.stack.medium};
  `);
const AccordionList = styled.ul(({ theme }) => css `
    margin: 0;
    padding: 0;
    list-style: none;
    width: 100%;
    box-sizing: border-box;

    & & {
      padding-left: ${theme.olist.spacing.inline.large};
    }

    li {
      margin-top: ${theme.olist.spacing.stack['1xsmall']};
    }
  `);
const StyledAccordionTrigger = styled(AccordionTrigger)(({ theme: { olist: { borderRadius, color, fontFamily }, }, }) => css `
    width: 100%;
    padding: 0;
    background-color: transparent;
    border: none;
    font-family: ${fontFamily.brand};
    border-radius: ${borderRadius.small};

    &:focus {
      outline: transparent;
      background-color: ${color.primary.softer};
      box-shadow: 0 0 0 1px ${color.neutral.softest},
        0 0 0 3px ${color.neutral.strong};
    }
  `);
const StyledAccordionItemGroup = styled.a(({ theme: { olist: { borderRadius, color, spacing }, }, isActive, isSideNavVisible, }) => css `
    width: 100%;
    box-sizing: border-box;
    padding-top: ${spacing.inset.small};
    padding-bottom: ${spacing.inset.small};
    padding-inline: ${isSideNavVisible ? spacing.inline.small : '0'};
    transition: ${!isSideNavVisible ? 'padding-inline 300ms linear' : 'none'};

    display: flex;
    gap: ${spacing.inline.small};
    align-items: center;

    color: ${color.neutral.strong};
    cursor: pointer;
    text-decoration: none;

    border-radius: ${borderRadius.small};

    &:hover {
      background-color: ${color.primary.softer};
    }

    &:focus {
      outline: transparent;
      background-color: ${color.primary.softer};
      box-shadow: inset 0 0 0 1px ${color.neutral.softest},
        inset 0 0 0 3px ${color.neutral.strong};
    }

    &:active {
      background-color: ${color.primary.soft};
    }

    svg {
      flex-shrink: 0;
    }

    > svg {
      flex-grow: 1;
    }

    ${ParagraphLg} {
      line-height: 1;
    }

    ${isActive &&
    css `
      color: ${color.primary.base};
      background-color: ${color.primary.softer};

      ${ParagraphLg} {
        color: ${color.primary.base};
      }
    `}
  `);
const AccordionItemText = styled.div(({ isSideNavExpanded, startAnimations, isSideNavVisible }) => css `
    width: 100%;
    display: ${isSideNavVisible ? 'flex' : 'none'};
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
    opacity: 0;

    ${startAnimations &&
    css `
      animation: ${isSideNavExpanded ? fadeIn : fadeOut}
        ${sideNavAnimationProperties};
    `};
  `);
const AccordionChevronIcon = styled(ChevronDownOutline)(({ $isOpened }) => css `
    transform: rotate(${$isOpened ? '180deg' : '0deg'});
    transition: transform ${sideNavTransitionProperties};
  `);
const StyledAccordionContent = styled.div(({ isOpened, height }) => css `
    overflow: hidden;
    ${height
    ? css `
          animation: ${isOpened ? slideDown(height) : slideUp(height)}
            ${sideNavAnimationProperties};
        `
    : ''}
  `);

export { AccordionChevronIcon, AccordionItemText, AccordionList, AccordionWrapper, StyledAccordionContent, StyledAccordionItemGroup, StyledAccordionTrigger };
